import React, { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle2, XCircle, Info } from 'lucide-react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info') => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 4000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="toast-container">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.type}`}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              {t.type === 'success' && <CheckCircle2 size={18} color="var(--color-success)" style={{ flexShrink: 0, marginTop: 1 }} />}
              {t.type === 'error' && <XCircle size={18} color="var(--color-danger)" style={{ flexShrink: 0, marginTop: 1 }} />}
              {t.type === 'info' && <Info size={18} color="var(--color-primary)" style={{ flexShrink: 0, marginTop: 1 }} />}
              <span>{t.message}</span>
            </div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
